import { Box, Card, Typography } from '@mui/material';
import { useSelector } from 'src/legacy/redux/store';

export const BasicInfoCard = () => {
  const { selectedCustomer } = useSelector((state) => state.customer);

  return (
    <Card
      sx={{
        mb: 3,
        position: 'relative',
      }}
    >
      <Box
        sx={{
          mx: 3,
          my: 2.5,
        }}
      >
        <Typography variant="h4">{selectedCustomer?.section || ''}</Typography>
        <Typography sx={{ opacity: 0.72 }}>
          {selectedCustomer?.name || ''}
        </Typography>
      </Box>
    </Card>
  );
};
